import React, {Fragment, Suspense} from 'react';
import './assets/legacy.css';
import LegacyFrame from "./LegacyFrame";
import {getSessionValue} from "../../Common/Appcommon";

class Search extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={true} pageTitle={"CRM"} formname={"search"} customClass={"field-customization-container"} />
        );
    } 
} 

export default Search;
